class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);
    if (event.target.type === 'number' || !this.currentVariant ||
      event.target.type === 'checkbox' || event.target.type === 'text') {
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updateInventory();
    this.updateWishlistComponent();
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateInventory() {
    const { sku, barcode } = this.currentVariant;
    this.currentVariantPrice = this.prices.find((priceObj) => {
      return priceObj.id === this.currentVariant?.id;
    });
    const { upc } = this.currentVariantPrice;
    const skuElement = this.querySelector('[data-sku]');
    const barcodeElement = this.querySelector(
      '[data-barcode-span]:not([data-meta])',
    );
    const productBarcodeElement = this.querySelector(
      'product-barcode:not([data-meta-barcode])',
    );

    if (skuElement) {
      skuElement.textContent = sku;
    }

    this.updateBarcodeElements(barcodeElement, productBarcodeElement, barcode);

    const upcBarcodeSpan = this.querySelector('[data-barcode-span][data-meta]');
    const upcProductBarcode = this.querySelector(
      'product-barcode[data-meta-barcode]',
    );

    this.updateBarcodeElements(upcBarcodeSpan, upcProductBarcode, upc);
  }

  /**
   * Updates the barcode elements with the provided value.
   *
   * @param {HTMLElement} span - The barcode span element to update.
   * @param {HTMLElement} barcode - The product barcode element to update.
   * @param {String} value - The new barcode value to set.
   * @returns {void}
   */
  updateBarcodeElements(span, barcode, value) {
    if (!span || !barcode) return;

    span.textContent = value;
    barcode.dataset.barcode = value;
    if (!value) return;
    barcode.init();
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
